<template>
  <router-view :company="company"></router-view>
</template>

<script>

import operativePageMixin from '../../../../mixins/operativePage';

export default {
  name: 'operative-inner-router',
  mixins: [operativePageMixin],
};

</script>
